import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DomainUrlService} from '../../../application/config/domain-url.service';
import {UserContextService} from '../../../application/app-context/user-context/user-context.service';
import {Account} from '../../core/model/account';
import {Assistance} from '../model/assistance';
import {AssistanceDocument} from '../model/assistance-document';
import {Portfolio} from '../../portfolio/model/portfolio';


@Injectable({
              providedIn: 'root'
            })
export class AssistanceService {

  readonly assistancesUrl = this.domainUrlService.getOptimPortalBackApiUrl() + '/rest/public/v1/ticket';
  readonly portfolioUrl = this.domainUrlService.getOptimPortalBackApiUrl() + '/rest/public/v1/portfolio';

  constructor(private http: HttpClient,
              private userContextService: UserContextService,
              private domainUrlService: DomainUrlService) {
  }

  getAssistances(): Observable<Array<Assistance>> {
    return this.http.get<Array<Assistance>>(this.assistancesUrl);
  }

  markAssistanceAsRead(assistance: Assistance): Observable<any> {
    return this.http.put(this.assistancesUrl + '/read/' + assistance.id, null);
  }

  addAssistance(assistance: Assistance): Observable<any> {
    return this.http.post(this.assistancesUrl, assistance);
  }

  addDocument(file: File, assistanceId: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(this.assistancesUrl + '/' + assistanceId + '/document', formData);
  }

  editAssistance(assistance: Assistance): Observable<any> {
    return this.http.put(this.assistancesUrl, assistance);
  }

  duplicateAssistance(assistance: Assistance, account: Account): Observable<any> {
    return this.http.post(this.assistancesUrl + '/' + assistance.id + '/' + assistance.solution + '/' + account.accountId + '/duplicate', null);
  }

  deleteAssistance(assistance: Assistance): Observable<any> {
    return this.http.delete(this.assistancesUrl + '/' + assistance.id);
  }

  openDocument(solution: string, document: AssistanceDocument): string {
    return this.assistancesUrl + '/read/' + this.userContextService.getUserContext().accountId + '/' + solution + '/' + document.id + '/' + document.uuidDocument + '/' + document.ownerDocument;
  }

  deleteDocument(assistance: Assistance, document: AssistanceDocument): Observable<any> {
    return this.http.delete(this.assistancesUrl + '/' + assistance.id + '/document/' + document.id);
  }

  getAccountPortfolio(): Observable<Array<Portfolio>> {
    return this.http.get<Array<Portfolio>>(this.portfolioUrl);
  }

}
